export default __webpack_public_path__ + "static/media/muchwow.18f2d627.gif";